import axios from "axios";
export const GET_SUBSCRIPTION_STATUS_SUCCESS =
  "GET_SUBSCRIPTION_STATUS_SUCCESS";
export const GET_SUBSCRIPTION_STATUS_ERROR = "GET_SUBSCRIPTION_STATUS_ERROR";

export const getSubscriptionStatusSuccess = (userDtls) => ({
  type: GET_SUBSCRIPTION_STATUS_SUCCESS,
  payload: userDtls,
});

export const getSubscriptionStatusError = (err) => ({
  type: GET_SUBSCRIPTION_STATUS_ERROR,
  payload: err,
});

let startTime = null;
const TIMEOUT = 30000;
const ERROR_MSG = "Request failed with status code 404";
const twoSeconds = 2000;

const EBSCO_CUST_SERVICE = "(833) 520-9694";

const getSubscriptionStatusUntilDelay = (dispatch, getState) => {
  if (new Date().getTime() - startTime < TIMEOUT) {
    setTimeout(() => getSubscriptionStatus()(dispatch, getState), twoSeconds);
  } else {
    throw new Error(
      " We’re having trouble activating your subscription. Please contact customer service at" +
        EBSCO_CUST_SERVICE +
        ". We are sorry for the inconvenience.",
    );
  }
};

export const getSubscriptionStatus = () => (dispatch, getState) => {
  startTime = startTime || new Date().getTime();
  const { api } = getState().paths;
  const url = `${api}/v1/subscription/activation/status`;
  return axios
    .get(url)
    .then((res) => {
      if (res.data.terminal) {
        dispatch(
          getSubscriptionStatusSuccess({
            data: res.data,
          }),
        );
      } else {
        getSubscriptionStatusUntilDelay(dispatch, getState);
      }
    })
    .catch((err) => {
      if (err.toString().includes(ERROR_MSG)) {
        getSubscriptionStatusUntilDelay(dispatch, getState);
      } else {
        dispatch(
          getSubscriptionStatusSuccess({
            data: { terminal: true, successful: false, msg: err.toString() },
          }),
        );
      }
    });
};
